var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3735 19.017L15.157 14.7931M9.50439 5.85825V9.14794M9.50439 9.14794V12.4376M9.50439 9.14794H12.7941M9.50439 9.14794H6.2147M17.4936 9.14794C17.4936 11.2668 16.6519 13.2989 15.1536 14.7972C13.6554 16.2955 11.6233 17.1372 9.50439 17.1372C7.38551 17.1372 5.35341 16.2955 3.85513 14.7972C2.35686 13.2989 1.51514 11.2668 1.51514 9.14794C1.51514 7.02906 2.35686 4.99696 3.85513 3.49869C5.35341 2.00041 7.38551 1.15869 9.50439 1.15869C11.6233 1.15869 13.6554 2.00041 15.1536 3.49869C16.6519 4.99696 17.4936 7.02906 17.4936 9.14794Z",
    stroke: "#00495F",
    strokeWidth: 1.87982,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.59f53635b929737ca30e6464a6cd7a1e.svg";
export { ForwardRef as ReactComponent };